import styled from "styled-components";

export const PlaylistContainer = styled.div`
  width: 100%;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: opacity 0.3s ease;

  contain: layout style paint;
  will-change: transform;

  transition: all 0.3s ease-in-out;

  &:active {
    scale: 0.975;
  }
`;

export const VideoElement = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: ${(props) => (props.$loaded ? "1" : "0")};
  visibility: ${(props) => (props.$loaded ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.$loaded ? "auto" : "none")};
  transition: opacity 0.4s ease;
  z-index: 1;
  border-radius: 12px;
  user-select: none;

  content-visibility: auto;
  will-change: opacity;
  transform: translateZ(0);
  backface-visibility: hidden;
`;

export const TemplateBadge = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  border-bottom-left-radius: 8px;
  z-index: 100;
  background: rgba(0, 0, 0, 0.5);
  padding: 4px 6px;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;

  color: #fafafa;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: -0.04px;
`;

export const Username = styled.div`
  color: rgba(255, 255, 255, 0.6);
  text-align: center;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.05px;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const PlaylistName = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 18px;
  line-height: 20px;
  font-weight: 700;
  margin-bottom: -5px;
  letter-spacing: -0.1px;
`;

export const PlaylistFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
  color: white;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.01) 80.05%,
    rgba(0, 0, 0, 0.7) 100%
  );
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 10;

  & > * {
    opacity: ${(props) => (props.$hideContent ? "0" : "1")};
    transform: translateY(${(props) => (props.$hideContent ? "20px" : "0")});
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`;

export const ImageElement = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;

  transition: opacity 0.4s ease;
  border-radius: 12px;
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(145deg, #152a47 0%, #0c1830 100%);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const EmptyStateIcon = styled.div`
  width: 80px;
  height: 56px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const PlayIcon = styled.div`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 0 10px 16px;
  border-color: transparent transparent transparent rgba(255, 255, 255, 0.4);
`;

export const ListLines = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ListLine = styled.div`
  width: 28px;
  height: 4px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 2px;
`;
